import axios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// Loading
import { Message } from 'element-ui'
// let loadingInstance = null // 这里是loading
let axiosNum = 0

// 使用create方法创建axios实例
export const Service = axios.create({
  timeout: 70000 // 请求超时时间
  // method: 'post',
  // headers: {
  //   'Content-Type': 'application/json;charset=UTF-8'
  // }
})

// 添加请求拦截器
Service.interceptors.request.use(config => {
  config.requestId = Date.now() + '-' + Math.random().toString(36).substring(2, 12)
  NProgress.start()
  axiosNum++
  // loadingInstance = Loading.service({
  //   lock: true,
  //   text: 'loading...'
  // })
  return config
})

// 添加响应拦截器
Service.interceptors.response.use(response => {
  axiosNum--
  if (axiosNum <= 0) {
    NProgress.done()
    // loadingInstance.close()
  }
  return response.data
}, error => {
  axiosNum--
  console.log('TCL: error', error)
  const msg = error.message !== undefined ? error.message : ''
  // 判断如果是网络异常，则不进行提示.
  if (msg !== 'Network Error') {
    Message({
      message: 'Network error 网络错误',
      type: 'error',
      duration: 3 * 1000
    })
  }
  if (axiosNum <= 0) {
    NProgress.done()
    // loadingInstance.close()
  }
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/request/http.js